import * as React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import UserAvatar from 'modules/core/components/UserAvatar'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { convertDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'
import { employeeUser } from 'modules/core/store/collections/users'

import type Employee from 'modules/employees/store/models/Employee'
import { hasPolicyTemporality } from 'modules/timeoff/lib/features/TimeoffFeatures'
import timeoffPolicies from 'modules/timeoff/store/collections/timeoffPolicies/policies'
import type TimeoffPolicy from 'modules/timeoff/store/models/TimeoffPolicy/Policy'

import Options from './Options'

interface Props {
  employee: Employee
  policy: TimeoffPolicy
  effectiveAt: string | null | undefined
}

const Item: React.FC<Props> = ({ employee, policy, effectiveAt }) => {
  const { navigation } = useNavigation()

  return (
    <Box padding="s16" flexDirection="row" width="full">
      <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center" width="full">
        <Box flexDirection="row" alignItems="center" paddingRight="s12">
          <Box paddingRight="s16">
            <UserAvatar size="s48" user={employeeUser(employee)} />
          </Box>
          <Box flexDirection="column">
            <Text.Normal color="grey1000" size="300" weight="medium">
              {employeeUser(employee).fullName()}
            </Text.Normal>
            {hasPolicyTemporality() && (
              <Text.Normal color="grey700" size="300">
                {effectiveAt
                  ? i18n.t('settings.timeoff_policies.employees.effective_at_date', {
                      date: convertDate(effectiveAt, 'backend', 'ui'),
                    })
                  : i18n.t('settings.timeoff_policies.employees.effective_at_contract')}
              </Text.Normal>
            )}
          </Box>
        </Box>
        <Box flexDirection="row">
          {!hasPolicyTemporality() && timeoffPolicies.models.length > 1 && (
            <Options employee={employee} policy={policy} />
          )}
          <Box>
            <Button.Router
              to={navigation.employees.id.timeOff.fullPath({ id: employee.id })}
              type="secondary"
              iconName="arrow-right"
            />
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default observer(Item)
